import * as wjcCore from '@mescius/wijmo';
// angular
import {Injectable} from '@angular/core';

// libs
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

// module
import {DatabaseService} from '../services';
import * as databaseAction from '../actions';

@Injectable()
export class DatabaseEffects {

  load$ = createEffect(() => this.actions$.pipe(
    ofType(databaseAction.ActionTypes.LOAD_DATABASE),
    map((action: any) => action.payload),
    switchMap((options) => {
      let database = '';
      if (!wjcCore.isString(options.database)) {
        database = options.database;
      }
      return this.databaseService.get(database).pipe(
        map((response: any) => new databaseAction.LoadDatabaseSuccessAction(response)),
        catchError(() => of(new databaseAction.LoadDatabaseFailureAction())),
      );
    })));

  list$ = createEffect(() => this.actions$.pipe(
    ofType(databaseAction.ActionTypes.LIST_DATABASES),
    map((action: any) => action.payload),
    switchMap((option) => {
      return this.databaseService.list(wjcCore.isString(option.url) ? option.url : undefined).pipe(
        map((response: any) => new databaseAction.ListDatabasesSuccessAction(response)),
        catchError(() => of(new databaseAction.ListDatabasesFailureAction())),
      );
    })));

  constructor(private actions$: Actions, private databaseService: DatabaseService) {
  }
}
